<template>
    <v-dialog v-model="dialog" scrollable
      max-width="70%" persistent>
      <v-card >
        <v-card-title>
          <v-row class="ma-0 pa-0">
            <v-spacer></v-spacer>
              <v-btn icon dark @click="close()">
                <v-icon color="primary">mdi-close</v-icon>
              </v-btn>
            <v-col class="pt-0 pb-0 text-center" cols="12">
             <h1>Adicionar Formulários de Recursos de Glosa</h1>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
         <v-row  wrap class="ma-0" v-if="dadosPagamento">
          <v-col class="text-left pb-4 pt-0" cols="4">
            <span class="card-title-form-guia textsRec" style="display: block">{{dadosPagamento.oper_nome}}</span>
            <span  class="card-title-form-guia" style="font-weight:normal; display: block">{{dadosPagamento.prest_nome }}</span>
          </v-col>
          <v-col class="text-left pb-4 pt-0" cols="4">
            <span class="card-title-form-guia textsRec" style="display: block">Data do pagamento: </span>
            <span style="font-size:16px;font-weight:bold">{{dadosPagamento.data_pagamento | formatDate}}</span>
          </v-col>
          <v-col class="text-left pb-4 pt-0" cols="4">
            <span class="card-title-form-guia textsRec" style="display: block">Total glosado (R$): </span>
            <span style="font-size:16px;font-weight:bold; color: error">{{ dadosPagamento.valor_glosado | formatPrice }}</span>
          </v-col>
        </v-row>
         <v-row class="ma-0">
        <!-- <v-col class="px-0" cols="12">
            <h1>Adicionar Lotes</h1>
        </v-col> -->
        <v-col class="px-0 pt-5" cols="12">
            <vue-dropzone
              ref="fileDropzone"
              class="pa-3"
              id="dropzone"
              :options="dropzoneOptions"
              @vdropzone-sending="sendFile"
              @vdropzone-error="rejectedFile"
            ></vue-dropzone>
            <!-- @vdropzone-queue-complete="completeMessage" -->
        </v-col>
      </v-row>
        </v-card-text>
        <!-- <v-card-actions>
          <v-btn depressed color="primary" @click="close()">
                FECHAR
              </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
</template>

<script>
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"

export default {
  components: {
        vueDropzone: vue2Dropzone
    },
  data() {
    return {
       dropzoneOptions: {
                url: process.env.VUE_APP_API_URL+"/api/proxy/upload",
                paramName: "File",
                multiple: true,
                uploadMultiple: false,
                resizeWidth: 200,
                resizeHeight: 50,
                acceptedFiles: '.xlsx',
                autoProcessQueue: true,
                duplicateCheck: true,
                dictDefaultMessage:
                `
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-file-outline primary--text" style='font-size: 35px; vertical-align: top'></i>
                <div style='display: inline-block; margin-top: -4px'>
                  Arraste o arquivo ou <span class="primary--text">selecione</span><br>Faça upload de arquivos apenas no formato <b>.xlsx</b>.
                </div>
                `,
                dictFallbackMessage: "Este browser não suporta a tecnologia utilizada para upload.",
                dictFallbackText: "Não entendi.",
                dictFileTooBig: "Não pode exceder {{filesize}}MB nem adicionar mais que {{maxFilesize}} arquivos.",
                dictInvalidFileType: "Tipo de arquivo não aceito.",
                dictResponseError: "Ocorreu erro {{statusCode}}",
                dictRemoveFile: "Clique para remover o arquivo",
                init: function() {
                  this.on("processing", function() {
                    let TOKEN =  'Bearer '.concat(sessionStorage.getItem('token'))
                    this.options.headers = {
                                Authorization: TOKEN
                              }
                  });
                }
            }
    }
  },
  // beforeMount() {
  //   this.TOKEN = 'Bearer '.concat(sessionStorage.getItem('token'))
  // },
  watch:{
    dialog(val){
      if(!val && this.$refs.fileDropzone) {
        this.$refs.fileDropzone.removeAllFiles();
      }
    },
  },
  mounted() {
        // this.prestadoresFilter = Array.from(this.prestadores)
        // if (this.prestadoresFilter.length==1) {
        //     this.formData.prestador_id = this.prestadoresFilter[0].id
        // } else {
            // this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        // }
  },
  methods: {
        rejectedFile(file, message) {
          if(!File.accepted) {
            var node = document.createElement("a")
            node.setAttribute('class','error-message')
            node.setAttribute('href','#')
            var textnode = document.createTextNode("remover arquivo")
            node.appendChild(textnode)
            node.addEventListener("click", e => {
              e.preventDefault()
              this.$refs.fileDropzone.removeFile(file)
            });
            file.previewElement.appendChild(node)
            message = JSON.parse(message)[0]
            let errorMessage = message.Payload.erros.map(err => err.descricao).join(' ')
             var errorDisplay = file.previewElement.querySelectorAll('[data-dz-errormessage]')
                    errorDisplay[errorDisplay.length - 1].innerHTML = errorMessage
            let paramModal = {
              type: "warning",
                title: "Atenção!",
                message: errorMessage? errorMessage : `Só são permitidos arquivos no formato <b>.xlsx</b>.`,
                callback: null,
                btConfirm: { name: "Ok", show: true },
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
          }
        },
        sendFile(file, xhr, formData){
              let grupo_economico = this.grupoEconomico
              let payload = JSON.stringify({ grupo_economico, pagamento_id: this.dadosPagamento.id})

              formData.append('Modulo', 'Recebiveis');
              formData.append('Acao', 'adddocumentoupload');
              formData.append('Payload', payload);
        },
        completeMessage(){
          // let comerro = this.$refs.fileDropzone.getRejectedFiles()
        //   let paramModal = {
        //           type: comerro.length? "error" : "success",
        //           title:  comerro.length? "Atenção!" : "Sucesso",
        //           message: comerro.length? 'Verifique os arquivos que não foram enviados' : "Os arquivos foram enviados com sucesso. ",
        //           callback:  null,
        //           btConfirm: { name: "Ok", show: true },
        //       }
        //       this.$store.commit("confirmMessage/showConfirmMessage", paramModal)


        //   // this.showUpload = false
          },
      removeUploadedFiles(files, rejected){
        if(!rejected) {
          this.$refs.fileDropzone.removeAllFiles()
        } else if(files && files.length){
          files.forEach(toDel => this.$refs.fileDropzone.removeFile(toDel))
        }
        this.getList(this.formData)
      }
  },
  props: {
    close: Function,
    dialog: Boolean,
    grupoEconomico: Number,
    dadosPagamento: Object
  },
};
</script>

<style>
.dropzone,
.dz-preview {
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;

}
.dropzone .dz-preview .dz-details .dz-size,
.dropzone .dz-preview .dz-details .dz-filename {
  font-size: 11px;
  margin-bottom:.5em;
  padding: 0;
  line-height: 11px;
}
.vue-dropzone>.dz-preview .dz-error-message{
  border-radius: 8px !important;
  top: -34px !important;
  font-size: .8em;
  line-height: 1.2em;
  padding: 5px;
}
.vue-dropzone>.dz-preview .dz-error-message:before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 54px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #a00909;
}
.vue-dropzone>.dz-preview .dz-error-mark {
  top: 20%;
}
.vue-dropzone>.dz-preview .dz-remove {
  position: absolute;
    width: 100%;
    color: #000;
    text-transform: lowercase;
    content: 'Excluir arquivo';
    margin-left: auto;
    padding: 10px;
    top: -8px;
    /* bottom: 15px; */
    border: 0;
    text-decoration: none;
    font-size: .8rem;
    font-weight: 400;
    letter-spacing: 0px; 
}
.vue-dropzone>.dz-preview .dz-remove:hover{
      text-decoration: none;

}
.dropzone {
  border-style: dashed;
  min-height: 80px;
  text-align: center;
}
.dz-preview {
  height: 80px;
  margin: 7px !important;
  width: 120px;
}

.dz-default,
.dz-default span {
  min-height: 20px;
}
a.error-message {
  cursor: pointer !important;
  text-decoration: none;
  z-index: 999;
}
</style>